// --------------------------------------------------------
// CARE LINE OCCUPATIONAL HEALTH FIELD - CareLineOccupHealthField
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React from 'react'
import Colors from '../../constants/Colors';
import useResponsiveInfo from '../../hooks/useResponsiveInfo';
import { AddButtonContainer } from '../../pages/careLine/CareLine.styled';
import { GenericSolidButton } from '../UI/buttons/Button.styled';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// CARE LINE OCCUPATIONAL HEALTH FIELD INTERFACE
// --------------------------------------------------------

interface ICareLineOccupHealthField{
    onAddField: any;
    isConfirmationState: boolean;
    isViewState: boolean;
    addButtonText: string;
    removeButtonText: string;
    disabled?: boolean;

}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const CareLineOccupHealthFieldButtonArea = (
    {
        onAddField, 
        disabled=false,
        isConfirmationState, 
        isViewState,
        addButtonText,
    }:ICareLineOccupHealthField) => {
  // --------------------------------------------------------
  // CARE LINE OCCUPATIONAL HEALTH FIELD PRIVATE DECLARATIONS
  // --------------------------------------------------------

    const { isMobile } = useResponsiveInfo()
  // --------------------------------------------------------

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>

            {!isConfirmationState && !isViewState && <AddButtonContainer isMobile={isMobile}>
                <GenericSolidButton
                    disabled={disabled}
                    type="button"
                    style={{ width: isMobile ? '100%' : 310, marginRight: isMobile? '':12, marginBottom: isMobile? 12 : '' }}
                    onClick={onAddField}
                    color={Colors.SPM600}
                >
                    <AddCircleOutlineIcon />{addButtonText}
                </GenericSolidButton>
            </AddButtonContainer>}
    </>
  )
  // --------------------------------------------------------
}

export default CareLineOccupHealthFieldButtonArea